<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="userform"
          status-icon
          :model="userform"
          :rules="rules"
          label-width="120px"
          style="width: 90%;"
        >
          <el-form-item label="用户名" prop="username">
            <el-input v-model="userform.username"></el-input>
          </el-form-item>
          <el-form-item label="登录名" prop="loginname">
            <el-input v-model="userform.loginname" :disabled="userform.caneditloginname"></el-input>
          </el-form-item>
          <el-form-item label="生日" prop="birthdate">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userform.birthdate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="userform.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="职务" prop="duty">
            <el-input v-model="userform.duty"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="userform.phone"></el-input>
          </el-form-item>
          <el-form-item label="允许编辑" prop="allowedit">
            <el-switch v-model="userform.allowedit" :width="80"></el-switch>
          </el-form-item>
          <el-form-item label="允许删除" prop="allowdelete">
            <el-switch v-model="userform.allowdelete" :width="80"></el-switch>
          </el-form-item>
          <el-form-item label="启用开始时间" prop="AllowUseStartTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userform.AllowUseStartTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="启用结束时间" prop="AllowUseEndTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userform.AllowUseEndTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="暂停开始时间" prop="PauseUseStartTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userform.PauseUseStartTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="暂停结束时间" prop="PauseUseEndTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="userform.PauseUseEndTime"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="Onsubmit('userform')">提交</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "UserInfoPage",
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        let reg = /^1[0-9]{10}$/;
        if (value == "" || value.length <= 10 || !reg.test(value)) {
          callback(new Error("手机号码格式不正确"));
        }
        callback();
      }
    };
    return {
      userform: {
        username: "",
        loginname: "",
        caneditloginname: true,
        birthdate: "",
        sex: "",
        duty: "",
        phone: "",
        allowedit: true,
        allowdelete: true,
        AllowUseStartTime: "",
        AllowUseEndTime: "",
        PauseUseStartTime: "",
        PauseUseEndTime: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        loginname: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        birthdate: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        AllowUseStartTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        AllowUseEndTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        PauseUseStartTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        PauseUseEndTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      resData: "",
    };
  },
  props: {
    SelectedOrgId: {
      type: String,
      default: "",
    },
    User_Id: {
      type: String,
      default: "",
    },
  },
  created: function () {
    this.userform.AllowUseStartTime = this.get_Day(0);
    this.userform.AllowUseEndTime = this.get_Day(10 * 356);
    this.userform.PauseUseStartTime = this.get_Day(-2);
    this.userform.PauseUseEndTime = this.get_Day(-1);
    this.userform.caneditloginname = false;
    this.GetInfo();
  },
  methods: {
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    GetInfo() {
      if (this.User_Id) {
        showLoading(".zj-form-container");
        this.userform.caneditloginname = true;
        let UserInfoSearch = {
          UserId: this.User_Id,
        };

        new WebApis.UserApi()
          .GetItemById(UserInfoSearch)
          .then((res) => {
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.userform.username = this.resData.UserName;
              this.userform.loginname = this.resData.LoginName;
              this.userform.birthdate = this.resData.Birthday;
              this.userform.sex = this.resData.Sex == 0 ? "女" : "男";
              this.userform.duty = "";
              this.userform.phone = this.resData.Phone;
              this.userform.allowedit = this.resData.AllowEdit == 1;
              this.userform.allowdelete = this.resData.AllowDelete == 1;
              this.userform.AllowUseStartTime = this.resData.AllowUseStartTime;
              this.userform.AllowUseEndTime = this.resData.AllowUseEndTime;
              this.userform.PauseUseStartTime = this.resData.PauseUseStartTime;
              this.userform.PauseUseEndTime = this.resData.PauseUseEndTime;

              hideLoading();
            }
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取用户信息失败!" + e.RspMsg
                : "获取用户信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    SaveData() {
      let UserInfoDTO = {
        Id: 0,
        UserId: "",
        Sex: this.userform.sex == "男" ? 1 : 0,
        Birthday: this.userform.birthdate,
        UserName: this.userform.username,
        LoginName: this.userform.loginname,
        LoginPwd: "",
        Phone: this.userform.phone,
        AllowEdit: this.userform.allowedit ? 1 : 0, //1是允许，0是不允许
        AllowDelete: this.userform.allowdelete ? 1 : 0, //1是允许，0是不允许
        AllowUseStartTime: this.userform.AllowUseStartTime,
        AllowUseEndTime: this.userform.AllowUseEndTime,
        PauseUseStartTime: this.userform.PauseUseStartTime,
        PauseUseEndTime: this.userform.PauseUseEndTime,
        Description: "",
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        UserEnabled: true,
        Validity: 1,
        Extend1: "",
        Extend2: "",
        IsCanCustom: 0,
        OrgId: this.SelectedOrgId,
      };

      if (this.resData) {
        UserInfoDTO.Id = this.resData.Id;
        UserInfoDTO.UserId = this.resData.UserId;
        UserInfoDTO.LoginPwd = this.resData.LoginPwd;
        UserInfoDTO.Description = this.resData.Description;
        UserInfoDTO.Extend1 = this.resData.Extend1;
        UserInfoDTO.Extend2 = this.resData.Extend2;
        UserInfoDTO.IsCanCustom = this.resData.IsCanCustom;
        UserInfoDTO.Modifier = this.user.UserName;
        UserInfoDTO.ModifyTime = new Date();

        this.UpdateData(UserInfoDTO);
      } else {
        this.InsertData(UserInfoDTO);
      }
    },
    InsertData(UserInfo) {
      new WebApis.UserApi()
        .InsertUser(UserInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "用户添加成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加用户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "用户添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户添加成功" : "添加用户失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "用户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加用户失败！" + e.RspMsg : "添加用户失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(UserInfo) {
      new WebApis.UserApi()
        .UpdateItem(UserInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "用户修改成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改用户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "用户修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户修改成功" : "修改用户失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "用户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改用户失败！" + e.RspMsg : "修改用户失败！",
            type: "error",
          });
          return false;
        });
    },
  },
};
</script>

<style>
</style>